/* eslint-disable import/extensions,import/no-unresolved,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member,no-constant-condition */
/**
 * Gets the repositories of the user from Github
 */

import { call, put, select, takeLatest, take } from 'redux-saga/effects';
import request, { reduxFileUpload, requestDownload } from 'utils/request';
import apiConfig from 'utils/apiConfig';
import { startProgress, endProgress } from 'containers/ProgressBar/actions';
import { showErrorToastr } from 'containers/Toastr/actions';
import { makeSelectPolicyId } from 'containers/App/selectors';
import { makeSelectClaimId, makeSelectClaimNumber, makeSelectClaimList, makeSelectSubmitted } from 'containers/ClaimList/selectors';
import {
  logoutSuccess,
  setMedicalAuthorityFormLink,
  setMedicalCertificateFormLink,
  setJSONVersion,
  setInsuredList,
  setGuardianClientRoles,
  setClaimPaymentVersion,
  setIsLinkedCover,
  setShowElectronicConsentDocument,
  setDeclarationClaimsAdminCompanyName,
  setTPAName,
  setCarrier,
  setShowRequiredDocument,
  setIsClaimGroupAllowed,
  setShowZurichUHC,
  setPolicyPurchaseDate,
  setPolicyEffectiveDate,
  setPolicyTerminationDate,
  setClaimantId,
  setIsClaimForFieldEnabled,
  setCellCaptiveCountryId,
  setPolicyTypeCode,
  setSpecifiedItems,
  setShowTrawickFNOLRefactoring,
  setShowTrawickPaymentScreen,
  setEventDescriptionLimit,
} from 'containers/App/actions';
import { resetLoginInfo } from 'containers/Login/actions';
import isAuthorised from 'utils/unauthoriseValidator';
import { makeSelectClaimTypeList } from 'containers/FastCover/StepWhatHappened/selectors';
import {
  loadFormData as loadForm2Data,
  resetFormData as resetForm2Data,
  loadClientDetail as loadForm2ClientDetail,
} from 'containers/FastCover/Step2/actions';
import {
  loadFormData as loadForm3Data,
  resetFormData as resetForm3Data,
} from 'containers/FastCover/Appsure.StepBankDetails/actions';
import {
  loadFormData as loadForm4Data,
  resetFormData as resetForm4Data,
} from 'containers/FastCover/Step4/actions';
import {
  loadFormData as loadForm5Data,
  resetFormData as resetForm5Data,
  getCountryList,
  getCountriesOfxSupported,
} from 'containers/FastCover/StepWhatHappened/actions';
import {
  loadFormData as loadForm6Data,
  resetFormData as resetForm6Data,
} from 'containers/FastCover/StepCancellationAdditional/actions';
import {
  loadFormData as loadForm7Data,
  resetFormData as resetForm7Data,
} from 'containers/FastCover/StepPersonalItems/actions';
import {
  loadFormData as loadForm8Data,
  resetFormData as resetForm8Data,
} from 'containers/FastCover/StepOverseasMedical/actions';
import {
  loadFormData as loadForm9Data,
  resetFormData as resetForm9Data,
} from 'containers/FastCover/StepRentalVehicle/actions';
import {
  loadFormData as loadForm10Data,
  resetFormData as resetForm10Data,
} from 'containers/FastCover/StepSnowSports/actions';
import {
  loadFormData as loadForm11Data,
  resetFormData as resetForm11Data,
} from 'containers/FastCover/StepOther/actions';
import {
  loadFormData as loadForm12Data,
  resetFormData as resetForm12Data,
  loadClaimAttachmentsSuccess,
} from 'containers/FastCover/StepSupportingDocuments/actions';
import {
  loadFormData as loadForm14Data,
  resetFormData as resetForm14Data,
} from 'containers/FastCover/StepDeclaration/actions';
import {
  loadFormData as loadForm15Data,
  resetFormData as resetForm15Data,
  resetFormGivePermissionState,
  setDefaultValue,
} from 'containers/FastCover/StepClaimSummary/actions';
import {
  loadFormData as loadForm18Data,
  resetFormData as resetForm18Data,
} from 'containers/FastCover/StepTripCancellationAndTripInterruption/actions';
import {
  loadFormData as loadForm19Data,
  resetFormData as resetForm19Data,
} from 'containers/FastCover/StepBaggageAndPersonalItems/actions';
import {
  loadFormData as loadForm20Data,
  resetFormData as resetForm20Data,
} from 'containers/FastCover/StepMedicalExpenses/actions';
import {
  loadFormData as loadForm21Data,
  resetFormData as resetForm21Data,
} from 'containers/FastCover/StepPaymentDetails/actions';
import {
  loadFormData as loadForm22Data,
  resetFormData as resetForm22Data,
} from 'containers/FastCover/StepBankDetails/actions';
import {
  loadFormData as loadFormMedicalExpenseStepData,
  resetFormData as resetFormMedicalExpenseStepData,
} from 'containers/FastCover/Trawick.NationWide.MedicalExpenseStep/actions';
import {
  loadFormData as loadFormTripCancellationStepData,
  resetFormData as resetFormTripCancellationStepData,
} from 'containers/FastCover/Trawick.NationWide.TripCancellationStep/actions';
import {
  loadFormData as loadFormPetMedicalStepData,
  resetFormData as resetFormPetMedicalStepData,
} from 'containers/FastCover/Trawick.NationWide.PetMedicalStep/actions';
import {
  loadFormData as loadFormPersonalItemStepData,
  resetFormData as resetFormPersonalItemStepData,
} from 'containers/FastCover/Trawick.NationWide.PersonalItemStep/actions';
import {
  loadFormData as loadFormPropertyDamageStepData,
  resetFormData as resetFormPropertyDamageStepData,
} from 'containers/FastCover/Trawick.NationWide.PropertyDamageStep/actions';
import {
  loadFormData as loadFormCollisionDamageStepData,
  resetFormData as resetFormCollisionDamageStepData,
} from 'containers/FastCover/Trawick.NationWide.CollisionDamageStep/actions';
import {
  loadFormData as loadFormAccidentalDeathAndDismembermentStepData,
  resetFormData as resetFormAccidentalDeathAndDismembermentStepData,
} from 'containers/FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/actions';
import {
  loadFormData as loadFormTripInterruptionStepData,
  resetFormData as resetFormTripInterruptionStepData,
} from 'containers/FastCover/Trawick.NationWide.TripInterruptionStep/actions';
import {
  loadFormData as loadFormTripDelayStepData,
  resetFormData as resetFormTripDelayStepData,
} from 'containers/FastCover/Trawick.NationWide.TripDelayStep/actions';
import {
  loadFormData as loadFormMissedConnectionStepData,
  resetFormData as resetFormMissedConnectionStepData,
} from 'containers/FastCover/Trawick.NationWide.MissedConnectionStep/actions';
import {
  loadFormData as loadFormSportsEquipmentStepData,
  resetFormData as resetFormSportsEquipmentStepData,
} from 'containers/FastCover/Trawick.NationWide.SportsEquipmentStep/actions';
import {
  loadFormData as loadFormMedicalHardshipStepData,
  resetFormData as resetFormMedicalHardshipStepData,
} from 'containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/actions';
import {
  loadFormData as loadFormJobLossHardshipStepData,
  resetFormData as resetFormJobLossHardshipStepData,
} from 'containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/actions';
import {
  loadFormData as loadFormDisasterAssistanceHardshipStepData,
  resetFormData as resetFormDisasterAssistanceHardshipStepData,
} from 'containers/FastCover/Trawick.DuesProtect.DisasterAssistanceHardshipStep/actions';
import {
  loadFormData as loadFormMedicalExpenseCFStepData,
  resetFormData as resetFormMedicalExpenseCFStepData,
} from 'containers/FastCover/Trawick.CFTripCan.MedicalExpense/actions';
import {
  loadFormData as loadFormMedicalExpenseZurichStepData,
  resetFormData as resetFormMedicalExpenseZurichStepData,
} from 'containers/FastCover/Trawick.Zurich.MedicalExpense/actions';
import {
  loadFormData as loadFormTripCancellationCFStepData,
  resetFormData as resetFormTripCancellationCFStepData,
} from 'containers/FastCover/Trawick.CFTripCan.TripCancellationStep/actions';
import {
  loadFormData as loadFormTravelDelayStepData,
  resetFormData as resetFormTravelDelayStepData,
} from 'containers/FastCover/StepTravelDelay/actions';
import {
  loadFormData as loadFormItineraryChangeStepData,
  resetFormData as resetFormItineraryChangeStepData,
} from 'containers/FastCover/Trawick.CFTripCan.ItineraryChange/actions';
import {
  loadFormData as loadFormMedicalAndEvacuationSCTIStepData,
  resetFormData as resetFormMedicalAndEvacuationSCTIStepData,
} from 'containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/actions';
import {
  loadFormData as loadFormChangesToYourJourneySCTIStepData,
  resetFormData as resetFormChangesToYourJourneySCTIStepData,
} from 'containers/FastCover/Trawick.SCTI.ChangesToYourJourney/actions';
import {
  loadFormData as loadFormBaggageAndPersonalItemsSCTIStepData,
  resetFormData as resetFormBaggageAndPersonalItemsSCTIStepData,
} from 'containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/actions';
import {
  loadFormData as loadFormCashBankCardsTravelDocumentsAndPassportsStepStepData,
  resetFormData as resetFormCashBankCardsTravelDocumentsAndPassportsStepData,
} from 'containers/FastCover/Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/actions';
import {
  loadFormData as loadFormPersonalAccidentSCTIStepData,
  resetFormData as resetFormPersonalAccidentSCTIStepData,
} from 'containers/FastCover/Trawick.SCTI.PersonalAccident/actions';
import {
  loadFormData as loadFormRentalVehicleExcessSCTIStepData,
  resetFormData as resetFormRentalVehicleExcessSCTIStepData,
} from 'containers/FastCover/Trawick.SCTI.RentalVehicleExcess/actions';

import {
  loadFormData as loadFromMedicalExpensesTugoStepData,
  resetFormData as resetFormMedicalExpensesTugoStepData,
} from 'containers/FastCover/Tugo.MedicalExpenses/actions';

import {
  loadFormData as loadFormChangesToYourJourneyStepData,
  resetFormData as resetFormChangesToYourJourneyStepData,
} from 'containers/FastCover/Trawick.ChangesToYourJourney/actions';
import {
  loadFormData as loadFormBaggageAndPersonalItemsStarrStepData,
  resetFormData as resetFormBaggageAndPersonalItemsStarrStepData,
} from 'containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/actions';
import {
  loadFormData as loadFormOtherStarrStepData,
  resetFormData as resetFormOtherStarrStepData,
} from 'containers/FastCover/Trawick.Starr.StepOther/actions';
import {
  loadFormData as loadFormCollisionDamageStarrStepData,
  resetFormData as resetFormCollisionDamageStarrStepData,
} from 'containers/FastCover/Trawick.Starr.StepCollisionDamage/actions';
import {
  loadFormData as loadFormOtherTugoStepData,
  resetFormData as resetFormOtherTugoStepData,
} from 'containers/FastCover/Tugo.StepOther/actions';

import {
  loadClaimListSuccess,
  updateSelectedClaimId,
  loadClaimSuccess,
  createNewClaimSuccess,
  updateSelectedClaimNumber,
  getTitleListSuccess,
  getDepreciationTypeListSuccess,
} from './actions';
import { makeSelectAuthToken } from '../Login/selectors';
import {
  LOAD_CLAIM_LIST,
  LOAD_CLAIM,
  CREATE_NEW_CLAIM,
  LOAD_CLAIM_FROM_SUMMARY,
  UPLOAD_CLAIM_SUMMARY,
  DOWNLOAD_SUMMARY,
  GET_TITLE_LIST,
  GET_SHOW_ELECTRONIC_CONSENT,
  GET_DEPRECIATION_TYPE_LIST,
} from './constants';
import { clientInfoMapper, mapBenefitCodeToAttachments, mapDataFromOldFnol } from './dataMapper';
import { mapTitleList, mapDepreciationTypeList } from '../FastCover/dataMapper/countryMapper';
import { setProgressIndicators, setVisitedStep } from '../Wizard/actions';

/**
 * Get list of claims
 */
function* getClaimList() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const requestURL = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/claims`;
  const requestOptions = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };
  const {
    requestUrl: getPolicyInsuredListRequest,
    requestOption: getPolicyInsuredListRequestOption,
  } = yield getPolicyInsuredsApiRequest();


  try {
    yield put(startProgress());
    const insuredList = yield call(request, getPolicyInsuredListRequest, getPolicyInsuredListRequestOption);
    const insureds = insuredList.payload.filter((x) => !x.isGuardian);
    const guardianClientRoles = insuredList.payload.filter((x) => x.isGuardian);
    yield put(setInsuredList(insureds));
    yield put(setGuardianClientRoles(guardianClientRoles));
    const res = yield call(request, requestURL, requestOptions);
    res.policy.insuredName = res.insureds.join(', ');
    yield put(loadClaimListSuccess(res.policy));
    yield put(setClaimPaymentVersion(res.policy.claimPaymentVersionUi));
    yield put(setIsLinkedCover(res.policy.isLinkedCover));
    yield put(setMedicalAuthorityFormLink(res.policy.medicalAuthorityFormLink));
    yield put(setMedicalCertificateFormLink(res.policy.medicalCertificateFormLink));
    yield put(setShowElectronicConsentDocument(res.showElectronicConsentDocument));
    yield put(setDeclarationClaimsAdminCompanyName(res.declarationClaimsAdminCompanyName));
    yield put(setTPAName(res.tpaName));
    yield put(setCarrier(res.carrier));
    yield put(setShowRequiredDocument(res.showRequiredDocument));
    yield put(setShowTrawickFNOLRefactoring(res.showTrawickFNOLRefactoring));
    yield put(setShowTrawickPaymentScreen(res.showTrawickPaymentScreen));
    yield put(setIsClaimGroupAllowed(res.isClaimGroupAllowed));
    yield put(setShowZurichUHC(res.showZurichUHC));
    yield put(setPolicyPurchaseDate(res.policy.fInceptionDate));
    yield put(setPolicyEffectiveDate(res.policy.fComDate));
    yield put(setPolicyTerminationDate(res.policy.fExpDate));
    yield put(setClaimantId(res.claimantId));
    yield put(setIsClaimForFieldEnabled(res.isAppsureMultiClaimant));
    yield put(setCellCaptiveCountryId(res.cellCaptiveCountryId));
    yield put(setPolicyTypeCode(res.policyTypeCode));
    yield put(setSpecifiedItems(res.specifiedItems));
    yield put(setEventDescriptionLimit(res.eventDescriptionLimit));
  } catch (err) {
    if (err.response.status === 401 || err.response.status === 403) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

function* getPolicyInsuredsApiRequest() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());

  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/insureds`;
  const requestOption = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

function* getClaimJsonApiRequest() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const claimId = yield select(makeSelectClaimId());

  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/claims/${claimId}/json`;
  const requestOption = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

function* getClaimAttachmentApiRequest() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const claimId = yield select(makeSelectClaimId());

  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/claims/${claimId}/attachments`;
  const requestOption = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

function* getClaimAttachmentGroupClaimApiRequest() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const claimId = yield select(makeSelectClaimId());

  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/claims/${claimId}/attachmentsGroupClaim`;
  const requestOption = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

function* getClaimCreationSource() {
  const token = yield select(makeSelectAuthToken());
  const claimId = yield select(makeSelectClaimId());

  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${claimId}/claimCreationSource`;
  const requestOption = {
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

/**
 * Get the JSON for the selected Claim
 */
function* loadClaim() {
  const {
    requestUrl: claimJsonRequest,
    requestOption: claimJsonRequestOption,
  } = yield getClaimJsonApiRequest();
  // const {
  //   requestUrl: claimAttachmentRequest,
  //   requestOption: claimAttachmentRequestOption,
  // } = yield getClaimAttachmentApiRequest();
  const {
    requestUrl: claimAttachmentRequest,
    requestOption: claimAttachmentRequestOption,
  } = yield getClaimAttachmentGroupClaimApiRequest();
  // try {
  // yield put(startProgress());
  const existingClaimJson = yield call(
    request,
    claimJsonRequest,
    claimJsonRequestOption
  );
  const existingClaimAttachment = yield call(
    request,
    claimAttachmentRequest,
    claimAttachmentRequestOption
  );

  yield put(setJSONVersion(existingClaimJson.version || '1'));
  const newVersion = existingClaimJson.version > 8;
  const isSubmitted = yield select(makeSelectSubmitted());
  const claimTypeList = yield select(makeSelectClaimTypeList());
  yield put(setShowRequiredDocument(existingClaimJson.showRequiredDocument));
  yield put(setShowTrawickFNOLRefactoring(existingClaimJson.showTrawickFNOLRefactoring));
  // const wizardData = JSON.parse(existingClaimJson.data) || {};
  const wizardData = mapDataFromOldFnol(JSON.parse(existingClaimJson.data), isSubmitted, claimTypeList, newVersion);

  if (newVersion) {
    yield put(loadForm2Data(wizardData.step2Data));
    yield put(loadForm3Data(wizardData.stepAppsureBankDetailsData));
    yield put(loadForm4Data(wizardData.step4Data));
    yield put(loadForm5Data(wizardData.stepWhatHappenedData));
    yield put(loadForm6Data(wizardData.stepCancellationAdditionalData));
    yield put(loadForm7Data(wizardData.stepPersonalItemsData));
    yield put(loadForm8Data(wizardData.stepOverseasMedicalData));
    yield put(loadForm9Data(wizardData.stepRentalVehicleData));
    yield put(loadForm10Data(wizardData.stepSnowSportsData));
    yield put(loadForm11Data(wizardData.stepOtherData));
    yield put(loadForm12Data(wizardData.stepSupportingDocumentsData));
    yield put(loadForm14Data(wizardData.stepDeclarationData));
    yield put(loadForm15Data(wizardData.stepClaimSummaryData));
    yield put(loadForm18Data(wizardData.stepTripCancellationAndTripInterruptionData));
    yield put(loadForm19Data(wizardData.stepBaggageAndPersonalItemsData));
    yield put(loadForm20Data(wizardData.stepMedicalExpensesData));
    if (wizardData.stepPaymentDetailsData === null) {
      yield put(resetForm21Data());
    } else {
      yield put(loadForm21Data(wizardData.stepPaymentDetailsData));
    }
    yield put(loadForm22Data(wizardData.stepBankDetailsData));
    yield put(loadFormMedicalExpenseStepData(wizardData.stepMedicalExpenseData));
    yield put(loadFormTripCancellationStepData(wizardData.stepTripCancellationData));
    yield put(loadFormTripInterruptionStepData(wizardData.stepTripInterruptionData));
    yield put(loadFormTripDelayStepData(wizardData.stepTripDelayData));
    yield put(loadFormPetMedicalStepData(wizardData.stepPetMedicalData));
    yield put(loadFormPersonalItemStepData(wizardData.stepPersonalItemData));
    yield put(loadFormPropertyDamageStepData(wizardData.stepPropertyDamageData));
    yield put(loadFormAccidentalDeathAndDismembermentStepData(wizardData.stepAccidentalDeathAndDismembermentData));
    yield put(loadFormCollisionDamageStepData(wizardData.stepCollisionDamageData));
    yield put(loadFormMissedConnectionStepData(wizardData.stepMissedConnectionData));
    yield put(loadFormSportsEquipmentStepData(wizardData.stepSportsEquipmentData));
    yield put(loadFormMedicalHardshipStepData(wizardData.stepMedicalHardshipData));
    yield put(loadFormJobLossHardshipStepData(wizardData.stepJobLossHardshipData));
    yield put(loadFormDisasterAssistanceHardshipStepData(wizardData.stepDisasterAssistanceHardshipData));
    yield put(loadFormMedicalExpenseCFStepData(wizardData.stepMedicalExpenseCFData));
    yield put(loadFormMedicalExpenseZurichStepData(wizardData.MedicalExpenseZurichStep));
    yield put(loadFormTripCancellationCFStepData(wizardData.stepTripCancellationCFData));
    yield put(loadFormTravelDelayStepData(wizardData.stepTravelDelayData));
    yield put(loadFormMedicalAndEvacuationSCTIStepData(wizardData.stepMedicalAndEvacuationSCTIData));
    yield put(loadFormChangesToYourJourneySCTIStepData(wizardData.stepChangesToYourJourneySCTIData));
    yield put(loadFormBaggageAndPersonalItemsSCTIStepData(wizardData.stepBaggageAndPersonalItemsSCTIData));
    yield put(loadFormCashBankCardsTravelDocumentsAndPassportsStepStepData(wizardData.stepCashBankCardsTravelDocumentsAndPassportsData));
    yield put(loadFormPersonalAccidentSCTIStepData(wizardData.stepPersonalAccidentSCTIData));
    yield put(loadFormRentalVehicleExcessSCTIStepData(wizardData.stepRentalVehicleExcessSCTIData));
    yield put(loadFormChangesToYourJourneyStepData(wizardData.stepChangesToYourJourneyData));
    yield put(loadFormBaggageAndPersonalItemsStarrStepData(wizardData.stepBaggageAndPersonalItemsStarrData));
    yield put(loadFormOtherStarrStepData(wizardData.stepOtherStarrData));
    yield put(loadFormCollisionDamageStarrStepData(wizardData.stepCollisionDamageStarrData));
    yield put(loadFormItineraryChangeStepData(wizardData.stepItineraryChangeData));
    yield put(loadFromMedicalExpensesTugoStepData(wizardData.stepMedicalExpensesTugoData));
    yield put(loadFormOtherTugoStepData(wizardData.stepOtherTugoData));
    yield put(setVisitedStep(wizardData.visitedStep));
    yield put(setProgressIndicators(wizardData.steps));
    yield put(loadClaimAttachmentsSuccess(mapBenefitCodeToAttachments((wizardData.stepSupportingDocumentsData && wizardData.stepSupportingDocumentsData.attachDocuments ? wizardData.stepSupportingDocumentsData.attachDocuments : []), existingClaimAttachment.attachments)));
    yield put(getCountryList());
    yield put(getCountriesOfxSupported());
  } else {
    yield put(loadForm2Data(wizardData.step2Data));
    yield put(loadForm3Data(wizardData.step3Data));
    yield put(loadForm4Data(wizardData.step4Data));
    yield put(loadForm5Data(wizardData.step5Data));
    yield put(loadForm6Data(wizardData.step6Data));
    yield put(loadForm7Data(wizardData.step7Data));
    yield put(loadForm8Data(wizardData.step8Data));
    yield put(loadForm9Data(wizardData.step9Data));
    yield put(loadForm10Data(wizardData.step10Data));
    yield put(loadForm11Data(wizardData.step11Data));
    yield put(loadForm12Data(wizardData.step12Data));
    yield put(loadForm14Data(wizardData.step14Data));
    yield put(loadForm15Data(wizardData.step15Data));
    yield put(loadForm18Data(wizardData.step18Data));
    yield put(loadForm19Data(wizardData.step19Data));
    yield put(loadForm20Data(wizardData.step20Data));
    yield put(loadForm21Data(wizardData.step21Data));
    yield put(loadForm22Data(wizardData.step22Data));
    yield put(loadFormMedicalExpenseStepData(wizardData.stepMedicalExpenseData));
    yield put(loadFormTripCancellationStepData(wizardData.stepTripCancellationData));
    yield put(loadFormTripInterruptionStepData(wizardData.stepTripInterruptionData));
    yield put(loadFormTripDelayStepData(wizardData.stepTripDelayData));
    yield put(loadFormPetMedicalStepData(wizardData.stepPetMedicalData));
    yield put(loadFormPersonalItemStepData(wizardData.stepPersonalItemData));
    yield put(loadFormPropertyDamageStepData(wizardData.stepPropertyDamageData));
    yield put(loadFormAccidentalDeathAndDismembermentStepData(wizardData.stepAccidentalDeathAndDismembermentData));
    yield put(loadFormCollisionDamageStepData(wizardData.stepCollisionDamageData));
    yield put(loadFormMissedConnectionStepData(wizardData.stepMissedConnectionData));
    yield put(loadFormSportsEquipmentStepData(wizardData.stepSportsEquipmentData));
    yield put(loadFormMedicalHardshipStepData(wizardData.stepMedicalHardshipData));
    yield put(loadFormJobLossHardshipStepData(wizardData.stepJobLossHardshipData));
    yield put(loadFormDisasterAssistanceHardshipStepData(wizardData.stepDisasterAssistanceHardshipData));
    yield put(loadFormMedicalExpenseCFStepData(wizardData.stepMedicalExpenseCFData));
    yield put(loadFormMedicalExpenseZurichStepData(wizardData.MedicalExpenseZurichStep));
    yield put(loadFormTripCancellationCFStepData(wizardData.stepTripCancellationCFData));
    yield put(loadFormTravelDelayStepData(wizardData.stepTravelDelayData));
    yield put(loadFormMedicalAndEvacuationSCTIStepData(wizardData.stepMedicalAndEvacuationSCTIData));
    yield put(loadFormChangesToYourJourneySCTIStepData(wizardData.stepChangesToYourJourneySCTIData));
    yield put(loadFormBaggageAndPersonalItemsSCTIStepData(wizardData.stepBaggageAndPersonalItemsSCTIData));
    yield put(loadFormCashBankCardsTravelDocumentsAndPassportsStepStepData(wizardData.stepCashBankCardsTravelDocumentsAndPassportsData));
    yield put(loadFormPersonalAccidentSCTIStepData(wizardData.stepPersonalAccidentSCTIData));
    yield put(loadFormRentalVehicleExcessSCTIStepData(wizardData.stepRentalVehicleExcessSCTIData));
    yield put(loadFormChangesToYourJourneyStepData(wizardData.stepChangesToYourJourneyData));
    yield put(loadFormBaggageAndPersonalItemsStarrStepData(wizardData.stepBaggageAndPersonalItemsStarrData));
    yield put(loadFormOtherStarrStepData(wizardData.stepOtherStarrData));
    yield put(loadFormCollisionDamageStarrStepData(wizardData.stepCollisionDamageStarrData));
    yield put(loadFormItineraryChangeStepData(wizardData.stepItineraryChangeData));
    yield put(loadFromMedicalExpensesTugoStepData(wizardData.stepMedicalExpensesTugoData));
    yield put(loadFormOtherTugoStepData(wizardData.stepOtherTugoData));
    yield put(setVisitedStep(wizardData.visitedStep));
    yield put(setProgressIndicators(wizardData.steps));
    yield put(loadClaimAttachmentsSuccess(mapBenefitCodeToAttachments((wizardData.step12Data && wizardData.step12Data.attachDocuments ? wizardData.step12Data.attachDocuments : []), existingClaimAttachment.attachments)));
    yield put(getCountryList());
    yield put(getCountriesOfxSupported());
  }
  // yield put(loadClaimSuccess());
  // } catch (err) {
  //   if (!isAuthorised(err.response)) {
  //     yield put(resetLoginInfo());
  //     yield put(logoutSuccess());
  //   } else {
  //     yield put(showErrorToastr(err.message));
  //   }
  // } finally {
  //   yield put(endProgress());
  // }
}

function* createNewClaimApiRequest() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/claims`;
  const requestOption = {
    method: 'POST',
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

function* getClientInfoApiRequest() {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const requestUrl = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/clients`;
  const requestOption = {
    method: 'GET',
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

/*
 * Create a new Claim with new Claim ID
 */
function* createClaim() {
  yield put(setJSONVersion(14));
  const {
    requestUrl: newClaimRequest,
    requestOption: newClaimRequestOption,
  } = yield createNewClaimApiRequest();
  const {
    requestUrl: clientInfoRequest,
    requestOption: clientInfoRequestOption,
  } = yield getClientInfoApiRequest();

  try {
    yield put(startProgress());
    const res = yield call(request, newClaimRequest, newClaimRequestOption);
    yield put(updateSelectedClaimId(res.claimParentId));
    yield put(updateSelectedClaimNumber(res.claimNumber));
    yield put(setShowRequiredDocument(res.showRequiredDocument));
    yield put(setShowTrawickFNOLRefactoring(res.showTrawickFNOLRefactoring));
    const response = yield call(
      request,
      clientInfoRequest,
      clientInfoRequestOption
    );
    const clientDetail = clientInfoMapper.map(response.payload);
    const claimData = yield select(makeSelectClaimList());
    yield put(resetForm2Data());
    yield put(loadForm2ClientDetail(clientDetail));
    yield put(resetForm3Data());
    yield put(resetForm4Data());
    yield put(resetForm5Data());
    yield put(resetForm6Data());
    yield put(resetForm7Data());
    yield put(resetForm8Data());
    yield put(resetForm9Data());
    yield put(resetForm10Data());
    yield put(resetForm11Data());
    yield put(resetForm12Data());
    yield put(resetForm14Data());
    yield put(resetForm15Data());
    yield put(resetForm18Data());
    yield put(resetForm19Data());
    yield put(resetForm20Data());
    yield put(resetForm21Data());
    yield put(resetForm22Data());
    yield put(resetFormMedicalExpenseStepData());
    yield put(resetFormTripCancellationStepData());
    yield put(resetFormTripInterruptionStepData());
    yield put(resetFormTripDelayStepData());
    yield put(resetFormPetMedicalStepData());
    yield put(resetFormPersonalItemStepData());
    yield put(resetFormPropertyDamageStepData());
    yield put(resetFormCollisionDamageStepData());
    yield put(resetFormAccidentalDeathAndDismembermentStepData());
    yield put(resetFormMissedConnectionStepData());
    yield put(resetFormSportsEquipmentStepData());
    yield put(resetFormMedicalHardshipStepData());
    yield put(resetFormJobLossHardshipStepData());
    yield put(resetFormDisasterAssistanceHardshipStepData());
    yield put(resetFormMedicalExpenseCFStepData());
    yield put(resetFormMedicalExpenseZurichStepData());
    yield put(resetFormTripCancellationCFStepData());
    yield put(resetFormTravelDelayStepData());
    yield put(resetFormMedicalAndEvacuationSCTIStepData());
    yield put(resetFormChangesToYourJourneySCTIStepData());
    yield put(resetFormBaggageAndPersonalItemsSCTIStepData());
    yield put(resetFormCashBankCardsTravelDocumentsAndPassportsStepData());
    yield put(resetFormPersonalAccidentSCTIStepData());
    yield put(resetFormRentalVehicleExcessSCTIStepData());
    yield put(resetFormChangesToYourJourneyStepData());
    yield put(resetFormBaggageAndPersonalItemsStarrStepData());
    yield put(resetFormOtherStarrStepData());
    yield put(resetFormCollisionDamageStarrStepData());
    yield put(resetFormItineraryChangeStepData());
    yield put(resetFormGivePermissionState());
    yield put(resetFormMedicalExpensesTugoStepData());
    yield put(resetFormOtherTugoStepData());
    yield put(setDefaultValue('form.preferredContactEmailForClaim', claimData.email));
    yield put(setDefaultValue('form.preferredContactNumberForClaim', claimData.mobileNumber || claimData.homePhoneNumber || claimData.fBusinessNumber));
    yield put(setDefaultValue('form.preferredContactForClaim', `${claimData.firstName} ${claimData.surname}`));

    yield put(setVisitedStep(0));
    yield put(setProgressIndicators([]));
    yield put(createNewClaimSuccess());
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

export function* getDepreciationTypes() {
  // TODO call API to get countries
  try {
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const policyId = yield select(makeSelectPolicyId());
    const requestUrl = `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/depreciationTypes`;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = mapDepreciationTypeList(response.payload);
      // set data for title list
      yield put(getDepreciationTypeListSuccess(rs));
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

export function* getTitles() {
  // yield put(startProgress());
  // TODO call API to get titles
  try {
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const requestUrl = `${apiConfig.restServiceDomain}/api/v1/Titles`;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      const rs = mapTitleList(response.payload);
      // set data for title list
      yield put(getTitleListSuccess(rs));

      // const stepPaymentDetailsData = yield select(makeSelectTitleList());
      // const isTitleFieldValid = _.find(rs, (d) => d.id === stepPaymentDetailsData.title);
      // if (!isTitleFieldValid && !!stepPaymentDetailsData.title) {
      //   yield put(handleFormDataChange('form.title', ''));
      // }
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

export function* getShowElectronicConsent() {
  // yield put(startProgress());
  try {
    const token = yield select(makeSelectAuthToken());
    const authToken = `bearer ${token}`;
    const policyId = yield select(makeSelectPolicyId());
    const requestUrl = `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/showElectronicConsent`;
    const requestOption = {
      method: 'GET',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(request, requestUrl, requestOption);
    if (response.isSuccess) {
      yield put(setShowElectronicConsentDocument(response.payload));
    }
  } catch (e) {
    console.log(e);
  } finally {
    // yield put(endProgress());
  }
}

// function* loadClaimType() { 
//   const token = yield select(makeSelectAuthToken());
//   const policyId = yield select(makeSelectPolicyId());
//   const claimId = yield select(makeSelectClaimId());
//   const requestURL = `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/claimTypes?claimParentId=${claimId}`;
//   const requestOptions = {
//     headers: {
//       Authorization: `bearer ${token}`,
//     },
//   };

//   try {
//     yield put(startProgress());
//     const res = yield call(request, requestURL, requestOptions);
//     yield put(setClaimTypes([...res.payload]));
//     yield put(loadClaimTypeSuccess(res.payload));
//   } catch (err) {
//     if (!isAuthorised(err.response)) {
//       yield put(resetLoginInfo());
//       yield put(logoutSuccess());
//     } else {
//       yield put(showErrorToastr(err.message));
//     }
//   } finally {
//     yield put(endProgress());
//   }
// }

function* loadClaimFromSummary() {
  let claimCreationSource = '';

  try {
    yield put(startProgress());
    const {
      requestUrl: claimRequest,
      requestOption: claimRequestOption,
    } = yield getClaimCreationSource();
    const rs = yield call(request, claimRequest, claimRequestOption);
    claimCreationSource = rs.payload;
    if (claimCreationSource !== 'FNOL') {
      yield put(showErrorToastr('This claim is not submitted via FNOL thus this FNOL form will appear blank.'));
      return;
    }
    yield loadClaim();
  } catch (err) {
    yield put(showErrorToastr(err.message));
  } finally {
    yield put(endProgress());
  }
}

function* loadClaimWizard() {
  try {
    yield put(startProgress());
    yield loadClaim();
    yield put(loadClaimSuccess());
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

export function* uploadClaimSummaryDocument(action) {
  yield put(startProgress());
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const claimId = yield select(makeSelectClaimId());

  const requestURL = `${apiConfig.restServiceDomain
    }/api/v1/policies/${policyId}/claims/${claimId}/attachments`;
  const authToken = `bearer ${token}`;
  const headers = {
    Authorization: authToken,
  };
  const formData = new FormData();
  formData.append('file', action.blob);
  formData.append('documentDescription', 'emailAttachment');

  const channel = yield call(reduxFileUpload, requestURL, headers, formData);

  while (true) {
    const { err, success } = yield take(channel);
    if (success) {
      return;
    }
    if (err) {
      yield put(showErrorToastr(err.message));
      return;
    }
  }
}

export function* downloadSummary({ cb }) {
  const token = yield select(makeSelectAuthToken());
  const policyId = yield select(makeSelectPolicyId());
  const claimId = yield select(makeSelectClaimId());
  const claimNumber = yield select(makeSelectClaimNumber());
  const queryString = new URLSearchParams(window.location.search);
  const email = queryString.get('email') || '';
  const requestURL = `${apiConfig.restServiceDomain}/api/v1/policies/${policyId}/claims/${claimId}/pdf?email=${email}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  try {
    yield put(startProgress());
    const response = yield call(requestDownload, requestURL, options);
    // download file pdf
    const newBlob = new Blob([response], { type: 'application/pdf' });
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, `${claimNumber} -  Claim Submission Summary.pdf`);
      return;
    }
    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = `${claimNumber} -  Claim Submission Summary.pdf`;
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 100);
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
    if (cb) {
      cb();
    }
  }
}

function* loadInsuredList() {
  try {
    yield put(startProgress());
    yield loadClaim();
    yield put(loadClaimSuccess());
  } catch (err) {
    if (!isAuthorised(err.response)) {
      yield put(resetLoginInfo());
      yield put(logoutSuccess());
    } else {
      yield put(showErrorToastr(err.message));
    }
  } finally {
    yield put(endProgress());
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* claimsList() {
  yield [
    takeLatest(LOAD_CLAIM_LIST, getClaimList),
    takeLatest(LOAD_CLAIM, loadClaimWizard),
    takeLatest(CREATE_NEW_CLAIM, createClaim),
    // takeLatest(LOAD_CLAIM_TYPE, loadClaimType),
    takeLatest(LOAD_CLAIM_FROM_SUMMARY, loadClaimFromSummary),
    takeLatest(UPLOAD_CLAIM_SUMMARY, uploadClaimSummaryDocument),
    takeLatest(DOWNLOAD_SUMMARY, downloadSummary),
    takeLatest(GET_TITLE_LIST, getTitles),
    takeLatest(GET_DEPRECIATION_TYPE_LIST, getDepreciationTypes),
    takeLatest(GET_SHOW_ELECTRONIC_CONSENT, getShowElectronicConsent),
  ];
}



// WEBPACK FOOTER //
// ./app/containers/ClaimList/saga.js